@if (isCustom) {
  <custom-view [component]="customComponent" [customDataBinding]="customData">
  </custom-view>
}

@if (!isCustom) {
  <common-chart [chartCriteria]="chartCriteria">
  </common-chart>
}
